/**
 * @generated SignedSource<<276bdcfea9690f276b624abf69dfff39>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteFileInput = {
  files?: ReadonlyArray<string | null> | null;
  taskId?: string | null;
  projectId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deleteFileMutationModernMutation$variables = {
  input: DeleteFileInput;
};
export type deleteFileMutationModernMutation$data = {
  readonly deleteFile: {
    readonly deletedFileIds: ReadonlyArray<string | null> | null;
  } | null;
};
export type deleteFileMutationModernMutation = {
  variables: deleteFileMutationModernMutation$variables;
  response: deleteFileMutationModernMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteFilePayload",
    "kind": "LinkedField",
    "name": "deleteFile",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedFileIds",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteFileMutationModernMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteFileMutationModernMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8c3f3e916a590fa77446838e15a4a884",
    "id": null,
    "metadata": {},
    "name": "deleteFileMutationModernMutation",
    "operationKind": "mutation",
    "text": "mutation deleteFileMutationModernMutation(\n  $input: DeleteFileInput!\n) {\n  deleteFile(input: $input) {\n    deletedFileIds\n  }\n}\n"
  }
};
})();

(node as any).hash = "8bb2b188b9c68923c33c3affbb914700";

export default node;
